import { buildAiComposerStyles } from '@wix/wix-emails-commons';
import posthtml from 'posthtml/lib';
export const addStyleFixes = mjml => {
  const styleFixes = tree => {
    const styleNode = {
      tag: 'mj-style',
      attrs: {},
      content: [buildAiComposerStyles('')]
    };
    tree.match({
      tag: 'mj-head'
    }, node => {
      if (!node.content) {
        node.content = [];
      }
      node.content.push(styleNode);
      return node;
    });
    return tree;
  };
  const withStyles = posthtml([styleFixes]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withStyles.html;
};
//# sourceMappingURL=add-style-fixes.js.map